export const faqs = [
    {
        q: "How long has Exportfy.world been in the export business?",
        a: "Exportfy.world has been actively operating as a merchant exporter for 5+ years, with continuous shipments to hotels, hospitals, retail chains, and distributors across five countries.",
    },
    {
        q: "Which countries does Exportfy.world currently export to?",
        a: "Exportfy.world currently exports to Mauritius, Brunei, Malaysia, Singapore, and Oman, with active expansion into the UAE, Saudi Arabia, Qatar, Kuwait, Bahrain, Africa, Europe, the USA, Canada, Australia, and Southeast Asia.",
    },
    {
        q: "Can I get a sample before placing a bulk order?",
        a: "Yes. Every product category supports paid or free samples depending on complexity. Sample cost is generally adjusted against the confirmed bulk order.",
    },
    {
        q: "What is the MOQ for hotel towels?",
        a: "Standard MOQ for custom hotel towels is 300–1,000 pcs per SKU. Lower quantities are available from our stock program for pilot orders.",
    },
    {
        q: "Do you offer OEM and private-label manufacturing?",
        a: "Yes. OEM and private-label programs are available across towels, home textiles, rugs, uniforms, safety products, and agro products, including custom weaving, printing, packaging, and hangtags.",
    },
    {
        q: "What certifications can Exportfy.world arrange for its shipments?",
        a: "We work with OEKO-TEX®, GOTS, BCI cotton, GoodWeave®, EN safety standards (EN 471, EN 20471, EN ISO 11612), FSSAI, APEDA, USDA Organic and EU Organic where required. Availability is category- and cluster-dependent.",
    },
    {
        q: "Can Exportfy.world help me start importing Indian products into my country?",
        a: "Yes. Our dedicated Import Business track for NRIs, freelancers, corporate professionals, and Amazon/e-commerce sellers covers product selection, supplier verification, sample-to-shipment, customs, branding, and ongoing sourcing support.",
    },
    {
        q: "How can Indian manufacturers or MSMEs work with Exportfy.world?",
        a: "Indian manufacturers, MSMEs, exporters and startups can partner with Exportfy.world to access verified international buyers, buying-house programs, and export-compliant packaging and documentation.",
    },
    {
        q: "What is Exportfy AI?",
        a: "Exportfy AI is our in-development AI-powered trade intelligence platform — AI Buyer Finder, AI Supplier Finder, AI Quotation Generator, AI HS Code Assistant, and AI Compliance Advisor. It is not yet live; you can join the waitlist for early access.",
    },
    {
        q: "How do I book a consultation with Exportfy.world?",
        a: "You can book a 30-minute or 60-minute consultation, an export audit, a sourcing consultation, or a market-entry strategy session directly from the Consultation page.",
    },
];
